export default "__VITE_ASSET__RoVF5A6t__"